import type { Ref } from 'vue'
import { lang } from './core/lang'

// Global: Declare -------------------------------
declare global {
  var $version: string
  var $debug: Record<string, any>
  var $lang: Ref<string>  
  var $fn: () => string
}

// Global: Initial -------------------------------
globalThis.$version = 'core v0.0.0'
globalThis.$debug = {}
globalThis.$lang = lang

globalThis.$fn = (): string => {
  var stack = new Error('dummy').stack?.split('\n')[2].replace(/^\s+at\s+(.+?)\s.+/g, '$1')
  return stack ?? 'unknown'
}

// -----------------------------------------------
export {}
